const { gql } = require("@apollo/client");

export const GET_USER_MEMBERSHIP = gql`
query GetUserSubscriptions($page: PageInput!, $filter: UserSubscriptionFilterInput) {
  getUserSubscriptions(page: $page, filter: $filter) {
    code
    success
    message
    total_count
    user_subscriptions {
      user_subscription_id
      user_id
      subscription_id
      start_date
      end_date
      status
      auto_renew
      metadata
      days_remaining
      is_active
      payment_info {
        payment_method
        transaction_id
        amount_paid
        currency
        payment_date
      }
      user_audit {
        created_by
        created_date
        modified_by
        modified_date
      }
      subscription_plan {
        subscription_id
        subscription_name {
          en
          ar
        }
        description {
          en
          ar
        }
        period_code
        period {
          code
          description {
            en
            ar
          }
          duration_days
        }
        amount
        currency
        category_code
        category {
          code
          description {
            en
            ar
          }
        }
        routes {
          route_id
          route_name {
            en
            ar
          }
          seat_types
          included
        }
        trips {
          trip_id
          trip_name {
            en
            ar
          }
          route_id
          time_slots
          days_of_week
          included
        }
        benefits {
          number_of_trips
          unlimited_trips
          miles
          miles_per_trip
          discount_percentage
          companion_discount
          priority_boarding
          lounge_access
          free_luggage_kg
          free_meal
          cancellation_flexibility {
            free_cancellation_hours
            refund_percentage
          }
          upgrade_options {
            free_upgrades
            upgrade_discount
          }
        }
        valid_from
        valid_to
        status_code
        is_active
        is_editable
        price_details {
          price
          vat
          price_with_vat
        }
        metadata {
          promo_code
          max_subscribers
          current_subscribers
          featured
          display_order
          terms_conditions {
            en
            ar
          }
          image_url
        }
        status {
          code
          description {
            en
            ar
          }
        }
        user_audit {
          created_by
          created_date
          modified_by
          modified_date
        }
      }
      price_details {
        price
        vat
        price_with_vat
      }
      status_desc {
        code
        description {
          en
          ar
        }
      }

    }
  }
}`;